<template>
  <div>
    <Drawer title="合伙人" width="600" :value="showEdit" :mask-closable="true" @on-close="cancelEdit">
      <Card style="margin-top: 5px">
        <Form ref="editForm" :label-width="100" :model="formData">
          <FormItem label="姓名" prop="name">
            <Input v-model="formData.name" placeholder="" maxlength="20"></Input>
          </FormItem>
          <FormItem label="手机号" prop="mobile">
            <Input v-model="formData.mobile" placeholder="" maxlength="11"></Input>
          </FormItem>
          <FormItem label="管理车队" prop="company">
            <Select v-model="formData.companys" multiple filterable>
              <Option value="">请选择</Option>
              <Option v-for="item in companys" :key="item.company_id" :value="item.company_id">{{ item.company_name }}</Option>
            </Select>
          </FormItem>
          <!--<FormItem label="显示油站" prop="stations">
            <Select v-model="formData.stations" multiple filterable>
              <Option value="">请选择</Option>
              <Option v-for="item in stations" :value="item.station_id">{{ item.gas_name }}</Option>
            </Select>
          </FormItem>-->

          <FormItem label="备注" prop="remark">
            <Input v-model="formData.remark" placeholder=""></Input>
          </FormItem>
        </Form>
      </Card>

      <div class="drawer-footer">
        <Button style="margin-right: 8px" @click="cancelEdit">取消</Button>
        <Button type="primary" @click="doSubmit">确定</Button>
      </div>
    </Drawer>
  </div>
</template>

<script>
  import config from '@/config/base-config'
  export default {
    name: "edit",
    props:{
      showEdit:{
        type:Boolean,
        default: false
      },
      id:{
        type:Number,
        default: 0
      }
    },
    data(){
      return {
        apiPath:config.API_PATH,
        formData:{
          name:'',
          mobile:'',
          remark:'',
          companys:[],
          //stations:[],
        },
        baseInfo:{},
        proofs:[],
        companys:[],
        //stations:[],
      }
    },
    methods:{
      async getInfo(){
        let res = await this.$commonFun.postProxy('admin/agent/getInfo',{id:this.id});
        if (this.id>0){
          let info = res.data.info
          this.id = info.id
          this.formData = {
            name:info.name,
            mobile:info.mobile,
            remark:info.remark,
            companys: info.companys,
           // stations: info.stations,
          }
        }
        this.companys = res.data.companys;
        //this.stations = res.data.stations
      },
      cancelEdit(){
         this.$emit('cancel-edit')
    },
      async doSubmit(){
        let _self = this;
        this.formData['id'] = this.id
        let res = await this.$commonFun.postProxy('admin/agent/edit',this.formData)
        //编辑成功刷新父页面
        this.$commonFun.dealApiResult(res,()=>{
          _self.$emit('edit-success')
          _self.$commonFun.successTip(res.msg)
        })
      },

    },
    mounted() {
      this.getInfo()
    },
  }
</script>

<style scoped lang="less">
  .drawer-footer{
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    border-top: 1px solid #e8e8e8;
    padding: 10px 16px;
    text-align: right;
    background: #fff;
  }

  .info-item{
    >span:nth-child(1){
      min-width: 100px;
      display: inline-block;
      text-align: right;
      letter-spacing: 2px;
      padding: 2px;
    }
    >span:nth-child(2){
      display: inline-block;
      padding-left: 10px;
    }
    .important-word{
      font-weight: bold;
      color: red;
    }
  }

</style>
